"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteScopeApi = exports.updateScopeApi = exports.createScopeApi = exports.getScopeApi = exports.getScopesApi = exports.deleteApiApi = exports.updateApiApi = exports.createApiApi = exports.getApiApi = exports.getApisApi = exports.deleteTenantApi = exports.updateTenantApi = exports.createTenantApi = exports.getTenantApi = exports.getTenantsApi = exports.getOpenidConfigurationApi = exports.deleteClientApi = exports.updateClientApi = exports.createClientApi = exports.getClientsApi = exports.getPermissionSetsApi = exports.getPermissionsApi = exports.deleteRoleApi = exports.updateRoleApi = exports.createRoleApi = exports.getRolesApi = exports.resetPasswordApi = exports.deleteUserApi = exports.changeUserPasswordApi = exports.updateUserApi = exports.createUserApi = exports.getUserApi = exports.getUsersApi = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _oauth = require("./oauth");

var _constants = require("./constants");

var _constants2 = require("./tenants/constants");

var sbFetchOAuth = _oauth.OAuth.sbFetchOAuth,
    fetchOAuth = _oauth.OAuth.fetchOAuth;
var PERMISSIONS = _constants.oAuthAPI.PERMISSIONS,
    ROLES = _constants.oAuthAPI.ROLES,
    USERS = _constants.oAuthAPI.USERS,
    CLIENTS = _constants.oAuthAPI.CLIENTS,
    OPENID_CONFIGURATION = _constants.oAuthAPI.OPENID_CONFIGURATION,
    PERMISSION_SETS = _constants.oAuthAPI.PERMISSION_SETS,
    TENANTS = _constants.oAuthAPI.TENANTS,
    APIS = _constants.oAuthAPI.APIS,
    scopes = _constants.oAuthAPI.scopes; // User Management

var getUsersApi = function getUsersApi() {
  var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_PAGE_SIZE;
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(USERS, "?pageSize=").concat(pageSize, "&pageNumber=").concat(pageNumber));
};

exports.getUsersApi = getUsersApi;

var getUserApi = function getUserApi(id) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(USERS, "/").concat(id));
};

exports.getUserApi = getUserApi;

var createUserApi = function createUserApi(user) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(USERS), {
    method: 'POST',
    body: JSON.stringify(user)
  });
};

exports.createUserApi = createUserApi;

var updateUserApi = function updateUserApi(user) {
  var id = user.id;
  return fetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(USERS, "/").concat(id), {
    method: 'PUT',
    body: JSON.stringify(user)
  });
};

exports.updateUserApi = updateUserApi;

var changeUserPasswordApi = function changeUserPasswordApi(user) {
  var id = user.id,
      oldPassword = user.oldPassword,
      password = user.password;
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(USERS, "/").concat(id, "/change-password"), {
    method: 'POST',
    body: JSON.stringify({
      old: oldPassword,
      new: password
    })
  });
};

exports.changeUserPasswordApi = changeUserPasswordApi;

var deleteUserApi = function deleteUserApi(id) {
  return fetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(USERS, "/").concat(id), {
    method: 'DELETE'
  });
};

exports.deleteUserApi = deleteUserApi;

var resetPasswordApi = function resetPasswordApi(id) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(USERS, "/").concat(id, "/reset-password"), {
    method: 'POST'
  });
}; // Roles management


exports.resetPasswordApi = resetPasswordApi;

var getRolesApi = function getRolesApi() {
  var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_PAGE_SIZE;
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(ROLES, "?pageSize=").concat(pageSize, "&pageNumber=").concat(pageNumber));
};

exports.getRolesApi = getRolesApi;

var createRoleApi = function createRoleApi(role) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(ROLES), {
    method: 'POST',
    body: JSON.stringify(role)
  });
};

exports.createRoleApi = createRoleApi;

var updateRoleApi = function updateRoleApi(role) {
  var id = role.id;
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(ROLES, "/").concat(id), {
    method: 'PUT',
    body: JSON.stringify(role)
  });
};

exports.updateRoleApi = updateRoleApi;

var deleteRoleApi = function deleteRoleApi(name) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(ROLES, "/").concat(name), {
    method: 'DELETE'
  });
}; // Permissions


exports.deleteRoleApi = deleteRoleApi;

var getPermissionsApi = function getPermissionsApi() {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(PERMISSIONS));
};

exports.getPermissionsApi = getPermissionsApi;

var getPermissionSetsApi = function getPermissionSetsApi() {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(PERMISSION_SETS));
}; // Clients


exports.getPermissionSetsApi = getPermissionSetsApi;

var getClientsApi = function getClientsApi() {
  var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_PAGE_SIZE;
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(CLIENTS, "?pageSize=").concat(pageSize, "&pageNumber=").concat(pageNumber));
};

exports.getClientsApi = getClientsApi;

var createClientApi = function createClientApi(_ref) {
  var tempId = _ref.tempId,
      client = (0, _objectWithoutProperties2.default)(_ref, ["tempId"]);
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(CLIENTS), {
    method: 'POST',
    body: JSON.stringify(client)
  });
};

exports.createClientApi = createClientApi;

var updateClientApi = function updateClientApi(_ref2) {
  var tempId = _ref2.tempId,
      client = (0, _objectWithoutProperties2.default)(_ref2, ["tempId"]);
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(CLIENTS, "/").concat(tempId), {
    method: 'PUT',
    body: JSON.stringify(client)
  });
};

exports.updateClientApi = updateClientApi;

var deleteClientApi = function deleteClientApi(id) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(CLIENTS, "/").concat(id), {
    method: 'DELETE'
  });
}; // Openid Configuration


exports.deleteClientApi = deleteClientApi;

var getOpenidConfigurationApi = function getOpenidConfigurationApi() {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(OPENID_CONFIGURATION));
}; // Tenants


exports.getOpenidConfigurationApi = getOpenidConfigurationApi;

var getTenantsApi = function getTenantsApi(_ref3) {
  var _ref3$pageSize = _ref3.pageSize,
      pageSize = _ref3$pageSize === void 0 ? _constants.DEFAULT_PAGE_SIZE : _ref3$pageSize,
      _ref3$pageNumber = _ref3.pageNumber,
      pageNumber = _ref3$pageNumber === void 0 ? 1 : _ref3$pageNumber,
      _ref3$parentTenantId = _ref3.parentTenantId,
      parentTenantId = _ref3$parentTenantId === void 0 ? null : _ref3$parentTenantId,
      _ref3$structure = _ref3.structure,
      structure = _ref3$structure === void 0 ? _constants2.TENANT_STRUCTURES.TREE : _ref3$structure;
  var parentTenant = parentTenantId ? "&tenantId=".concat(parentTenantId) : '';
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(TENANTS, "?pageSize=").concat(pageSize, "&pageNumber=").concat(pageNumber).concat(parentTenant, "&structure=").concat(structure));
};

exports.getTenantsApi = getTenantsApi;

var getTenantApi = function getTenantApi(tenantId) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(TENANTS, "/").concat(tenantId));
};

exports.getTenantApi = getTenantApi;

var createTenantApi = function createTenantApi(tenant) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(TENANTS), {
    method: 'POST',
    body: JSON.stringify(tenant)
  });
};

exports.createTenantApi = createTenantApi;

var updateTenantApi = function updateTenantApi(tenant) {
  var id = tenant.id;
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(TENANTS, "/").concat(id), {
    method: 'PUT',
    body: JSON.stringify(tenant)
  });
};

exports.updateTenantApi = updateTenantApi;

var deleteTenantApi = function deleteTenantApi(id) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(TENANTS, "/").concat(id), {
    method: 'DELETE'
  });
}; // Apis


exports.deleteTenantApi = deleteTenantApi;

var getApisApi = function getApisApi() {
  var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_PAGE_SIZE;
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(APIS, "?pageSize=").concat(pageSize, "&pageNumber=").concat(pageNumber));
};

exports.getApisApi = getApisApi;

var getApiApi = function getApiApi(apiId) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(APIS, "/").concat(apiId));
};

exports.getApiApi = getApiApi;

var createApiApi = function createApiApi(_ref4) {
  var tempId = _ref4.tempId,
      api = (0, _objectWithoutProperties2.default)(_ref4, ["tempId"]);
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(APIS), {
    method: 'POST',
    body: JSON.stringify(api)
  });
};

exports.createApiApi = createApiApi;

var updateApiApi = function updateApiApi(_ref5) {
  var tempId = _ref5.tempId,
      api = (0, _objectWithoutProperties2.default)(_ref5, ["tempId"]);
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(APIS, "/").concat(tempId), {
    method: 'PUT',
    body: JSON.stringify(api)
  });
};

exports.updateApiApi = updateApiApi;

var deleteApiApi = function deleteApiApi(id) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(APIS, "/").concat(id), {
    method: 'DELETE'
  });
}; // Scopes (Apis)


exports.deleteApiApi = deleteApiApi;

var getScopesApi = function getScopesApi(apiId) {
  return function () {
    var pageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_PAGE_SIZE;
    var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(scopes(apiId), "?pageSize=").concat(pageSize, "&pageNumber=").concat(pageNumber));
  };
};

exports.getScopesApi = getScopesApi;

var getScopeApi = function getScopeApi(apiId, scopeId) {
  return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(scopes(apiId), "/").concat(scopeId));
};

exports.getScopeApi = getScopeApi;

var createScopeApi = function createScopeApi(apiId) {
  return function (_ref6) {
    var tempId = _ref6.tempId,
        api = (0, _objectWithoutProperties2.default)(_ref6, ["tempId"]);
    return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(scopes(apiId)), {
      method: 'POST',
      body: JSON.stringify(api)
    });
  };
};

exports.createScopeApi = createScopeApi;

var updateScopeApi = function updateScopeApi(apiId) {
  return function (_ref7) {
    var tempId = _ref7.tempId,
        api = (0, _objectWithoutProperties2.default)(_ref7, ["tempId"]);
    return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(scopes(apiId), "/").concat(tempId), {
      method: 'PUT',
      body: JSON.stringify(api)
    });
  };
};

exports.updateScopeApi = updateScopeApi;

var deleteScopeApi = function deleteScopeApi(apiId) {
  return function (id) {
    return sbFetchOAuth("".concat(_oauth.OAuth.config.IDENTITY_SERVER_URL).concat(scopes(apiId), "/").concat(id), {
      method: 'DELETE'
    });
  };
};

exports.deleteScopeApi = deleteScopeApi;
//# sourceMappingURL=rest.js.map